import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';
import type { ChangesAgencyFilterCatalog } from '../types/changesAgencyFilter';

const emptyAgencyCatalog: ChangesAgencyFilterCatalog = {
  federacao: [],
  estados: [],
  municipios: [],
};

export function useChangesColumnFilterCatalogs(enabled = true) {
  const states = useQuery(['changes-state-filter-options'], () => apiService.getChangesStateFilterOptions(), {
    staleTime: 10 * 60 * 1000,
    enabled,
  });
  const agencies = useQuery(
    ['changes-agency-filter-catalog', 'v4-state-catalog-ui'],
    () => apiService.getChangesAgencyFilterOptions(),
    { staleTime: 10 * 60 * 1000, enabled },
  );
  const lawTypes = useQuery(['changes-lawtype-filter-options'], () => apiService.getChangesLawTypeFilterOptions(), {
    staleTime: 10 * 60 * 1000,
    enabled,
  });
  const changeTypes = useQuery(
    ['changes-changetype-filter-options'],
    () => apiService.getChangesChangeTypeFilterOptions(),
    { staleTime: 10 * 60 * 1000, enabled },
  );

  return {
    states: states.data ?? [],
    agencyCatalog: agencies.data ?? emptyAgencyCatalog,
    lawTypes: lawTypes.data ?? [],
    changeTypes: changeTypes.data ?? [],
    isLoading: states.isLoading || agencies.isLoading || lawTypes.isLoading || changeTypes.isLoading,
  };
}

